import { render, staticRenderFns } from "./invoices_detail_invoices_view.vue?vue&type=template&id=1d93e730&scoped=true&"
import script from "./invoices_detail_invoices_view.vue?vue&type=script&lang=js&"
export * from "./invoices_detail_invoices_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d93e730",
  null
  
)

export default component.exports